import React from 'react'
import {cn} from '@/helpers/shadcn/utils'
import {useIntl} from 'react-intl'
import {PageHeader} from '@/components/molecules'

const PageContent = ({title, pageHeaderContent, pageContentWrapperClassName, className, children, ...props}) => {
  const {formatMessage} = useIntl()

  return (
    <div className={cn('flex flex-col text-base', pageContentWrapperClassName)} {...props}>
      {(title || pageHeaderContent) && (
        <PageHeader title={title ? formatMessage({id: title}) : ''} className="">
          {pageHeaderContent}
        </PageHeader>
      )}
      <div
        className={cn('shadow mb-3 mt-2 flex w-full flex-col rounded-lg border-none bg-layer-01 p-6', className)}
        data-cy="page-content"
      >
        {children}
      </div>
    </div>
  )
}

export default PageContent
